import { T } from '../../styles/theme'
import { StatTile, SectionLabel } from '../../components/ui'

export default function Dashboard({ patients }) {
  const total = patients.length
  const conAlertas = patients.filter(p => p.status !== 'green').length
  const sinDatos = patients.filter(p => !p.peso).length

  return (
    <div>
      <div style={{ padding: '52px 20px 12px' }}>
        <div style={{ fontSize: 26, fontWeight: 700, letterSpacing: -0.5 }}>Dashboard</div>
        <div style={{ fontSize: 13, color: T.muted, marginTop: 2 }}>Resumen del equipo</div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, margin: '0 16px 12px' }}>
        {[
          [total, 'Pacientes activos'],
          [conAlertas, 'Con alertas'],
          [sinDatos, 'Sin datos de peso'],
          [total - conAlertas, 'En buen seguimiento'],
        ].map(([v, l]) => (
          <StatTile key={l} value={v} label={l} />
        ))}
      </div>

      <SectionLabel style={{ margin: '16px 20px 8px' }}>Estado pacientes</SectionLabel>
      <div style={{ margin: '0 16px' }}>
        {patients.map(p => {
          const col = p.status === 'green' ? T.accent : p.status === 'yellow' ? T.warn : T.danger
          return (
            <div key={p.id} style={{ marginBottom: 12 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                <span style={{ fontSize: 13 }}>{p.nombre}</span>
                <span style={{ fontSize: 12, color: col, fontWeight: 600 }}>
                  {p.status === 'green' ? '✓ Bien' : p.status === 'yellow' ? '⚠ Revisar' : '✗ Alerta'}
                </span>
              </div>
              <div style={{ height: 4, background: T.cardB, borderRadius: 2, overflow: 'hidden' }}>
                <div style={{ height: '100%', borderRadius: 2, background: col, width: p.status === 'green' ? '100%' : p.status === 'yellow' ? '50%' : '20%' }} />
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}